import drawerTemplateUrl from "servicestack/tags/navigator/tag-navigator-drawer.htm";
import drawersTemplateUrl from "servicestack/tags/navigator/tag-navigator-drawers.htm";
import accordionTemplateUrl from "servicestack/tags/navigator/tag-navigator-accordion.htm";

export default {
  drawer: drawerTemplateUrl,
  drawers: drawersTemplateUrl,
  accordion: accordionTemplateUrl,
  "wrapped-accordion": accordionTemplateUrl
};
